var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "leader-details" },
    [
      _c(
        "el-row",
        [
          _c(
            "el-col",
            { attrs: { span: 24 } },
            [
              _c(
                "el-descriptions",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.formLoading,
                      expression: "formLoading",
                    },
                  ],
                  staticClass: "margin-top",
                  staticStyle: { width: "100%" },
                  attrs: { column: 1, border: "" },
                },
                [
                  _c(
                    "el-descriptions-item",
                    {
                      attrs: {
                        label: "姓名",
                        labelStyle: _vm.descriptionLableStyle,
                        contentStyle: { "text-align": "center" },
                      },
                    },
                    [
                      _c("template", { slot: "label" }, [_vm._v(" 姓名 ")]),
                      _c(
                        "div",
                        {
                          staticClass: "avatar-upload",
                          staticStyle: { "flex-direction": "column" },
                        },
                        [
                          _vm.formData.name
                            ? _c(
                                "el-tag",
                                {
                                  staticClass: "desc-tag name-tag",
                                  attrs: { type: "success" },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.formData.name +
                                        " " +
                                        (_vm.formData.nickName
                                          ? "(" + _vm.formData.nickName + ")"
                                          : "")
                                    )
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._l(_vm.formData.avatar, function (item, index) {
                            return [
                              _c(
                                "div",
                                { key: index, staticClass: "avatar-preview" },
                                [
                                  _c("el-image", {
                                    attrs: {
                                      fit: "cover",
                                      "preview-src-list": item.url
                                        ? [item.url]
                                        : [_vm.emptyUserImg],
                                      src: item.url
                                        ? item.url
                                        : _vm.emptyUserImg,
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          }),
                        ],
                        2
                      ),
                    ],
                    2
                  ),
                  _c(
                    "el-descriptions-item",
                    {
                      attrs: {
                        label: "出團數",
                        labelStyle: _vm.descriptionLableStyle,
                        contentStyle: { "text-align": "center" },
                      },
                    },
                    [
                      _c("template", { slot: "label" }, [_vm._v(" 出團數 ")]),
                      _c(
                        "el-tag",
                        { staticClass: "desc-tag", attrs: { type: "danger" } },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.formData.toursCount
                                  ? _vm.formData.toursCount
                                  : 0
                              )
                          ),
                        ]
                      ),
                    ],
                    2
                  ),
                  _c(
                    "el-descriptions-item",
                    {
                      attrs: {
                        label: "電話",
                        labelStyle: _vm.descriptionLableStyle,
                        contentStyle: { "text-align": "center" },
                      },
                    },
                    [
                      _c("template", { slot: "label" }, [_vm._v(" 電話 ")]),
                      _vm.formData.mobile
                        ? _c("el-tag", { staticClass: "desc-tag" }, [
                            _vm._v(" " + _vm._s(_vm.formData.mobile)),
                          ])
                        : _vm._e(),
                    ],
                    2
                  ),
                  _c(
                    "el-descriptions-item",
                    {
                      attrs: {
                        label: "生日",
                        labelStyle: _vm.descriptionLableStyle,
                        contentStyle: { "text-align": "center" },
                      },
                    },
                    [
                      _c("template", { slot: "label" }, [_vm._v(" 生日 ")]),
                      _vm.formData.birthday
                        ? _c("el-tag", { staticClass: "desc-tag" }, [
                            _vm._v(" " + _vm._s(_vm.formData.birthday) + " "),
                          ])
                        : _vm._e(),
                    ],
                    2
                  ),
                  _c(
                    "el-descriptions-item",
                    {
                      attrs: {
                        label: "姓名",
                        labelStyle: _vm.descriptionLableStyle,
                        contentStyle: { "text-align": "center" },
                      },
                    },
                    [
                      _c("template", { slot: "label" }, [_vm._v(" 領隊相片 ")]),
                      _c(
                        "div",
                        {
                          staticClass: "avatar-upload",
                          staticStyle: { "flex-direction": "row" },
                        },
                        [
                          _vm._l(_vm.formData.file1, function (item, index) {
                            return [
                              _c(
                                "div",
                                { key: index },
                                [
                                  _c("el-image", {
                                    attrs: {
                                      fit: "cover",
                                      "preview-src-list": item.url
                                        ? [item.url]
                                        : [_vm.emptyUserImg],
                                      src: item.url
                                        ? item.url
                                        : _vm.emptyUserImg,
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          }),
                        ],
                        2
                      ),
                    ],
                    2
                  ),
                  _c(
                    "el-descriptions-item",
                    {
                      attrs: {
                        label: "介紹",
                        labelStyle: _vm.descriptionLableStyle,
                        contentStyle: { "text-align": "center" },
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: { disabled: true, type: "textarea", rows: 7 },
                        model: {
                          value: _vm.formData.selfDescription,
                          callback: function ($$v) {
                            _vm.$set(_vm.formData, "selfDescription", $$v)
                          },
                          expression: "formData.selfDescription",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-descriptions-item",
                    {
                      attrs: {
                        label: "經歷",
                        labelStyle: _vm.descriptionLableStyle,
                        contentStyle: { "text-align": "center" },
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: { disabled: true, type: "textarea", rows: 7 },
                        model: {
                          value: _vm.formData.experience,
                          callback: function ($$v) {
                            _vm.$set(_vm.formData, "experience", $$v)
                          },
                          expression: "formData.experience",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-descriptions-item",
                    {
                      attrs: {
                        label: "專長",
                        labelStyle: _vm.descriptionLableStyle,
                        contentStyle: { "text-align": "center" },
                      },
                    },
                    [
                      _vm._l(_vm.specialtyLabels, function (specialty) {
                        return _c(
                          "el-tag",
                          {
                            key: specialty,
                            staticClass: "specialty-tag",
                            attrs: { type: "success", size: "small" },
                          },
                          [_vm._v(" " + _vm._s(specialty) + " ")]
                        )
                      }),
                      _vm.specialtyLabels.length === 0
                        ? _c("span", [_vm._v("未提供")])
                        : _vm._e(),
                    ],
                    2
                  ),
                  _c(
                    "el-descriptions-item",
                    {
                      attrs: {
                        label: "履歷設定",
                        labelStyle: _vm.descriptionLableStyle,
                        contentStyle: { "text-align": "center" },
                      },
                    },
                    [
                      _c(
                        "el-tag",
                        {
                          attrs: {
                            type: _vm.privacy.isProfilePublic
                              ? "success"
                              : "info",
                          },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.privacy.isProfilePublic
                                  ? "公開履歷"
                                  : "不公開履歷"
                              ) +
                              " "
                          ),
                        ]
                      ),
                      _c(
                        "el-tag",
                        {
                          attrs: {
                            type: _vm.privacy.acceptInvitations
                              ? "success"
                              : "info",
                          },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.privacy.acceptInvitations
                                  ? "接受邀約"
                                  : "不接受邀約"
                              ) +
                              " "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-descriptions-item",
                    {
                      attrs: {
                        label: "證照說明",
                        labelStyle: _vm.descriptionLableStyle,
                        contentStyle: { "text-align": "center" },
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticStyle: { display: "flex" } },
                        _vm._l(_vm.formData.file2, function (item, index) {
                          return _c("el-image", {
                            key: index,
                            staticStyle: {
                              width: "200px",
                              height: "200px",
                              display: "list-item",
                              margin: "5px",
                              border: "1px solid black",
                            },
                            attrs: {
                              fit: "cover",
                              "preview-src-list": item.url
                                ? [item.url]
                                : [_vm.emptyUserImg],
                              src: item.url ? item.url : _vm.emptyUserImg,
                            },
                          })
                        }),
                        1
                      ),
                      _c("el-input", {
                        attrs: { disabled: true, type: "textarea", rows: 7 },
                        model: {
                          value: _vm.formData.certificatesRemark,
                          callback: function ($$v) {
                            _vm.$set(_vm.formData, "certificatesRemark", $$v)
                          },
                          expression: "formData.certificatesRemark",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }